import React from "react";
import NestedRedirect from "../components/NestedRedirect";

export default (path) => () => <NestedRedirect to={path} />;
